export default {
  ATCOSME        : 'atcosme',
  BEAUTY_BOARD   : 'beauty_board',
  INTERNAL_SYSTEM: 'internal_system',
};
